import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { Svg, TempurLogoTextWhite } from "../svg";

/**
 * Native port of ``cms/blocks/hc-block/hc-block--certipur-us.html``.
 *
 * The legacy ``static_image`` renders EAGER under puppeteer (lazy=False) -- a
 * plain ``<img>`` with the static URL -- so we emit a plain eager ``<img>`` whose
 * ``src`` is built from the reactivated ``STATIC_URL`` context
 * (``useStaticURL``); this is SSR-safe and byte-identical to the legacy
 * ``{% static %}`` output, unlike a Vite asset import.
 */
export const CertipurUs = (): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <>
            <img
                src={`${staticURL}img/hardcoded/certipur-us-logo.png`}
                alt={t`CertiPUR-US® Contains Certified Flexible Polyurethane Foam www.certipur.us logo`}
                loading="lazy"
                decoding="async"
            />
            <div>
                <Svg
                    Icon={TempurLogoTextWhite}
                    src="tempur-logo-text-white"
                    title={t`Tempur-Pedic`}
                />
                <h1>Sleep with Confidence</h1>
                <p>
                    Rest easy knowing the performance foam used in this product
                    is 100% CertiPUR-US® certified.
                </p>
                <ul>
                    <li>Made without ozone depleters</li>
                    <li>
                        Made without PBDEs, TDCPP or TCEP (“Tris”) flame
                        retardants
                    </li>
                    <li>Made without formaldehyde</li>
                    <li>Made without mercury, lead or other heavy metals</li>
                </ul>
            </div>
        </>
    );
};
